export const articleDetail = {
  id: 1,
  title: '我独自升级',
  author: 'Chugong（原作）/ Dubu（作画）',
  category: '热血',
  cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20solo%20leveling%20theme%2C%20dark%20fantasy%20warrior%20with%20glowing%20blue%20eyes%2C%20dramatic%20pose%2C%20dynamic%20action%2C%20illustration%20with%20clean%20lines%20and%20vibrant%20color%20contrast%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=800&height=1120&seq=article-cover-01&orientation=portrait',
  rating: 9.7,
  status: '连载中',
  views: '2980万',
  description: '10年前，世界与其他次元链接的"门"被打开，随之而来的是被称为"猎人"的人类觉醒力量。某一天，最低等级的E级猎人成振宇在前所未有的双重地下城中，迎来了人生的转折点——他被赋予了"系统"，成为了唯一一个能不断升级变强的存在。从此，他从"人类最弱兵器"逐步成长为统御暗影的最强猎人。一场关于力量、责任与命运的热血冒险就此展开。',
  tags: ['系统流', '暗影君主', '成长', '爽文', '战斗'],
  chapters: [
    { id: 1, number: 187, title: '终章：暗影君主', updateDate: '2026-07-03', isNew: true },
    { id: 2, number: 186, title: '最后的决战', updateDate: '2026-06-26', isNew: false },
    { id: 3, number: 185, title: '觉醒的力量', updateDate: '2026-06-19', isNew: false },
    { id: 4, number: 184, title: '暗影军团', updateDate: '2026-06-12', isNew: false },
    { id: 5, number: 183, title: '王座之下', updateDate: '2026-06-05', isNew: false },
    { id: 6, number: 182, title: '光芒与暗影', updateDate: '2026-05-29', isNew: false },
    { id: 7, number: 181, title: '不屈的意志', updateDate: '2026-05-22', isNew: false },
    { id: 8, number: 180, title: '超越极限', updateDate: '2026-05-15', isNew: false },
  ],
};

export const articleDetail2 = {
  id: 2,
  title: '神之塔',
  author: 'SIU',
  category: '奇幻',
  cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20tower%20of%20god%20theme%2C%20mysterious%20boy%20climbing%20a%20giant%20tower%2C%20fantasy%20world%20elements%2C%20magical%20atmosphere%2C%20illustration%20with%20rich%20colors%20and%20detailed%20background%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=800&height=1120&seq=article-cover-02&orientation=portrait',
  rating: 9.5,
  status: '连载中',
  views: '1850万',
  description: '少年夜一直在黑暗封闭的空间中生活，唯一的慰藉就是他的朋友蕾哈尔。蕾哈尔告诉夜，塔的顶端可以看到真正的星空，为了实现这个梦想，蕾哈尔进入了神之塔。为了追寻蕾哈尔，夜也打开了塔的大门。每一层塔都充满了考验和危险，夜必须不断成长，结识新的伙伴，才能一步步攀登到塔的顶端。这部漫画构建了一个庞大而精妙的奇幻世界，是韩国漫画的经典之作。',
  tags: ['神之塔', '奇幻冒险', '友情', '成长', '长篇'],
  chapters: [
    { id: 1, number: 632, title: '新的旅程', updateDate: '2026-07-03', isNew: true },
    { id: 2, number: 631, title: '塔顶的秘密', updateDate: '2026-06-26', isNew: false },
    { id: 3, number: 630, title: '最后的关卡', updateDate: '2026-06-19', isNew: false },
    { id: 4, number: 629, title: '伙伴的力量', updateDate: '2026-06-12', isNew: false },
    { id: 5, number: 628, title: '未知的领域', updateDate: '2026-06-05', isNew: false },
  ],
};

export const articleDetail3 = {
  id: 3,
  title: '女神降临',
  author: 'Yaongyi',
  category: '恋爱',
  cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20romance%20theme%2C%20beautiful%20girl%20with%20makeup%20transformation%2C%20school%20setting%2C%20love%20triangle%20vibe%2C%20soft%20pastel%20color%20palette%2C%20illustration%20with%20clean%20lines%2C%20professional%20manhwa%20art%2C%20simple%20light%20background%20with%20subtle%20gradient&width=800&height=1120&seq=article-cover-03&orientation=portrait',
  rating: 9.3,
  status: '已完结',
  views: '3560万',
  description: '女高中生林周京因为对外表缺乏自信，通过精湛的化妆技巧在学校里成为了人人羡慕的"女神"。然而，她的素颜秘密却被学校里最受欢迎的两位男生——李修豪和韩书俊知道了。一个是冷傲的校园男神，一个是阳光的校园偶像，两人对周京的态度从嘲讽到心动。周京在化妆带来的自信和真实的自己之间挣扎，展开了一段关于自我认同与爱情的甜蜜成长故事。',
  tags: ['校园恋爱', '化妆', '变身', '爱情喜剧', '自我成长'],
  chapters: [
    { id: 1, number: 223, title: '最终话：真正的我', updateDate: '2026-06-20', isNew: false },
    { id: 2, number: 222, title: '告白', updateDate: '2026-06-13', isNew: false },
    { id: 3, number: 221, title: '选择', updateDate: '2026-06-06', isNew: false },
    { id: 4, number: 220, title: '内心的声音', updateDate: '2026-05-30', isNew: false },
    { id: 5, number: 219, title: '真实的勇气', updateDate: '2026-05-23', isNew: false },
  ],
};

export const articleDetail4 = {
  id: 4,
  title: '剑尊归来',
  author: '有金 / LICO',
  category: '武侠',
  cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20martial%20arts%20swordsman%20theme%2C%20ancient%20Korean%20warrior%20with%20sword%2C%20dramatic%20wind%20effect%2C%20traditional%20clothing%2C%20illustration%20with%20dynamic%20brushwork%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=800&height=1120&seq=article-cover-04&orientation=portrait',
  rating: 9.6,
  status: '连载中',
  views: '2200万',
  description: '天下第一剑尊在飞升之际被最信任的弟子背叛，含恨陨落。然而，命运给了他第二次机会——他重生到了百年之后一个没落门派的废柴弟子身上。昔日站在武道巅峰的他，如今要从最底层重新崛起。凭借着前世的记忆和绝世剑法，他一步步重登巅峰，誓要清算旧账，揭开当年背叛的真相。这是一部集重生、复仇、热血于一身的武侠漫画巨作。',
  tags: ['重生', '剑道', '热血', '武侠', '复仇'],
  chapters: [
    { id: 1, number: 128, title: '剑道巅峰', updateDate: '2026-07-03', isNew: true },
    { id: 2, number: 127, title: '宿命对决', updateDate: '2026-06-26', isNew: false },
    { id: 3, number: 126, title: '剑意通神', updateDate: '2026-06-19', isNew: false },
    { id: 4, number: 125, title: '绝世一剑', updateDate: '2026-06-12', isNew: false },
    { id: 5, number: 124, title: '风云再起', updateDate: '2026-06-05', isNew: false },
  ],
};

export const articleDetail5 = {
  id: 5,
  title: '全知读者视角',
  author: 'sing N song / Sleepy-C',
  category: '奇幻',
  cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20apocalyptic%20fantasy%20theme%2C%20protagonist%20in%20modern%20clothing%20facing%20monsters%2C%20dramatic%20scene%2C%20dark%20atmosphere%20with%20glowing%20elements%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=800&height=1120&seq=article-cover-05&orientation=portrait',
  rating: 9.4,
  status: '连载中',
  views: '1680万',
  description: '金独子是一个平凡的上班族，唯一的爱好就是阅读一部名为《在灭亡世界中生存的三种方法》的网络小说。这部小说连载了十年，其他读者早已失去兴趣，只有他坚持读到了最后。就在小说完结的那一天，小说中的世界突然变成了现实——怪物降临，文明崩塌。而作为唯一的"全知读者"，金独子拥有了别人没有的优势：他知道这个世界将会发生的一切。',
  tags: ['末世', '系统', '全知', '生存', '长篇'],
  chapters: [
    { id: 1, number: 215, title: '世界的真相', updateDate: '2026-07-03', isNew: true },
    { id: 2, number: 214, title: '最后的篇章', updateDate: '2026-06-26', isNew: false },
    { id: 3, number: 213, title: '超越命运', updateDate: '2026-06-19', isNew: false },
    { id: 4, number: 212, title: '星流之战', updateDate: '2026-06-12', isNew: false },
    { id: 5, number: 211, title: '读者的选择', updateDate: '2026-06-05', isNew: false },
    { id: 6, number: 210, title: '回归之路', updateDate: '2026-05-29', isNew: false },
  ],
};

export const articleDetail6 = {
  id: 6,
  title: '重生之都市修仙',
  author: '大行道',
  category: '玄幻',
  cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20cultivation%20fantasy%20theme%2C%20modern%20city%20with%20supernatural%20elements%2C%20young%20man%20with%20spiritual%20energy%20effects%2C%20illustration%20with%20vibrant%20colors%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=800&height=1120&seq=article-cover-06&orientation=portrait',
  rating: 9.2,
  status: '连载中',
  views: '1780万',
  description: '仙界第一仙尊重生回到了五百年前的地球。这一世，他带着前世的记忆和修仙功法归来，从一个小小的都市少年开始，重新踏上修炼之路。在这个灵气复苏的新时代，他一边修炼一边解决前世留下的种种遗憾——保护家人，惩戒仇敌，收服各路天才。都市修仙、校园风云、家族恩怨，一切尽在这部玄幻巨作中。',
  tags: ['重生', '都市', '修仙', '逆袭', '爽文'],
  chapters: [
    { id: 1, number: 342, title: '重返巅峰', updateDate: '2026-07-02', isNew: true },
    { id: 2, number: 341, title: '仙界之门', updateDate: '2026-06-25', isNew: false },
    { id: 3, number: 340, title: '天劫降临', updateDate: '2026-06-18', isNew: false },
    { id: 4, number: 339, title: '不死真身', updateDate: '2026-06-11', isNew: false },
    { id: 5, number: 338, title: '万法归宗', updateDate: '2026-06-04', isNew: false },
  ],
};

export const articleDetail7 = {
  id: 7,
  title: '漂亮干姐姐',
  author: 'Dalso',
  category: '恋爱',
  cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20office%20romance%20theme%2C%20handsome%20man%20and%20beautiful%20woman%20in%20modern%20setting%2C%20romantic%20atmosphere%2C%20soft%20warm%20color%20palette%2C%20professional%20manhwa%20art%2C%20simple%20light%20background%20with%20subtle%20gradient&width=800&height=1120&seq=article-cover-07&orientation=portrait',
  rating: 9.1,
  status: '连载中',
  views: '980万',
  description: '刚毕业的职场新人李在勋进入了一家大公司，却发现自己的直属上司竟然是小时候邻居家的"干姐姐"——那个曾经照顾过他、又突然搬走的漂亮姐姐。十年后重逢，她变得更加成熟迷人，而他也不再是当年那个小屁孩了。在职场与爱情的交织中，一段年下男与年上女的甜蜜恋爱开始了。',
  tags: ['职场恋爱', '姐弟恋', '年下', '浪漫', '日常'],
  chapters: [
    { id: 1, number: 89, title: '重逢之后', updateDate: '2026-07-03', isNew: true },
    { id: 2, number: 88, title: '心动的瞬间', updateDate: '2026-06-26', isNew: false },
    { id: 3, number: 87, title: '雨中的告白', updateDate: '2026-06-19', isNew: false },
    { id: 4, number: 86, title: '无法隐藏的心意', updateDate: '2026-06-12', isNew: false },
    { id: 5, number: 85, title: '初雪之夜', updateDate: '2026-06-05', isNew: false },
  ],
};

export const articleDetail8 = {
  id: 8,
  title: '狂暴战神',
  author: 'Redice Studio',
  category: '热血',
  cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20fierce%20battle%20theme%2C%20muscular%20warrior%20in%20combat%20pose%2C%20explosive%20action%20scene%2C%20dramatic%20lighting%20with%20shadows%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=800&height=1120&seq=article-cover-08&orientation=portrait',
  rating: 9.0,
  status: '连载中',
  views: '1250万',
  description: '在一个被"神之试炼"笼罩的世界里，每隔百年就会选出十二位战士代表人类与神明对决。主角姜太浩原本只是一个普通的格斗选手，却在一次意外中被选为第十二位战士。为了守护家人和人类的未来，他必须在有限的三年内将自己磨练成最强的战士。这是一部充满热血与激情的格斗漫画，每一场战斗都让人热血沸腾。',
  tags: ['格斗', '热血', '战斗', '竞技', '成长'],
  chapters: [
    { id: 1, number: 156, title: '终极试炼', updateDate: '2026-07-02', isNew: true },
    { id: 2, number: 155, title: '绝境爆发', updateDate: '2026-06-25', isNew: false },
    { id: 3, number: 154, title: '不屈之魂', updateDate: '2026-06-18', isNew: false },
    { id: 4, number: 153, title: '生死之战', updateDate: '2026-06-11', isNew: false },
    { id: 5, number: 152, title: '觉醒时刻', updateDate: '2026-06-04', isNew: false },
  ],
};

export const allArticles: Record<number, typeof articleDetail> = {
  1: articleDetail,
  2: articleDetail2,
  3: articleDetail3,
  4: articleDetail4,
  5: articleDetail5,
  6: articleDetail6,
  7: articleDetail7,
  8: articleDetail8,
};